import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AMControllerService } from 'src/app/shared/dbcontroller/dbcontroller.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { TabService } from '../admin-layout/tab.service';
import * as Screenfull from "screenfull";
// import { stdinfo } from 'src/app/school/student/registration/regstrationclass';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html"
})
export class HeaderComponent {
  @Output()
  toggleSidenav = new EventEmitter<void>();
  @Output()
  toggleNotificationSidenav = new EventEmitter<void>();
  // filteredStdListOptions: Observable<stdinfo[]>;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;


  currSession = new FormControl();
  public compName = "";

  selectedValue: string;
  selectedCar: string;


  // filteredStudents: Observable<stdinfo[]>;

  constructor(
    public controllerService: AMControllerService,
    public dialog: MatDialog,
    private router: Router,
    private tabService: TabService
  ) {
    // this.filteredStudents = this.stdCtrl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(std => std ? this._filterStudents(std) : this.studentslist.slice())
    //   );
    // this.studentslist = this.controllerService.studentslist;

    // this.filteredStdListOptions = this.stdCtrl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this.controllerService._Studentfilter(this.controllerService.studentslist, value))
    //   );
    this.compName = this.controllerService.complist.find(x => x.comp_id == this.controllerService.userinfo.compid).name;

    this.currSession.setValue(this.controllerService.fiscalyears.find(x => x.sessid == this.controllerService.currfiscalyr.sessid));
  }

  public onSessionChange() {
    this.controllerService.currfiscalyr = this.currSession.value;
    // this.controllerService.showDialogSuccessInfo(this.controllerService.currfiscalyr.sessid);
  }


  // openStudent() {

  //   // this.controllerService.showDialogSuccessInfo(value);
  //   let stdrow = this.controllerService.studentslist.find(x => x.id == Number(this.stdCtrl.value));

  //   if (stdrow == null) {
  //     this.controllerService.showDialogFailedInfo("No Student Exists");
  //     return;
  //   }

  //   if (this.controllerService.studentdocs != null && this.controllerService.studentdocs.length > 0) {
  //     stdrow.std_docs = this.controllerService.studentdocs.filter(x => x.stdid == stdrow.id);
  //   }

  //   this.stdCtrl.setValue("");
  //   this.controllerService.tempVal = null;
  //   this.dialog.open(RegistrationComponent, {
  //     data: { resdatainfo: stdrow },
  //     disableClose: true
  //   });

  //   this.autocompleteTrigger.closePanel();
  // }
  // private _filterStudents(value: string): stdinfo[] {
  //   // const filterValue = value.toLowerCase();
  //   // return this.studentslist.filter(std => (std.stdname.toLowerCase().indexOf(filterValue) === 0));
  //   return this.studentslist.filter(std => (std.stdadmno == Number(value)));
  // }

  fullScreenToggle(): void {
    if (Screenfull.isEnabled) {
      Screenfull.toggle();
    }
  }

  signOut(): void {
    if (this.controllerService.socket?.connected) {
      this.controllerService.socket.disconnect();
    }
    this.controllerService.isotplogin = false;
    this.controllerService.userinfo = null;
    this.tabService.tabs = [];
    this.tabService.tabSub.next([]);
    this.router.navigate(['/session/forgot']);
  }
}
